import { render, staticRenderFns } from "./CountryBadge.vue?vue&type=template&id=9c69e8b2&scoped=true&"
import script from "./CountryBadge.vue?vue&type=script&lang=js&"
export * from "./CountryBadge.vue?vue&type=script&lang=js&"
import style0 from "./CountryBadge.vue?vue&type=style&index=0&id=9c69e8b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c69e8b2",
  null
  
)

export default component.exports